/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsColumn: {
  name: 'column';
  data: string;
} = {
  name: 'column',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 .5A1.5 1.5 0 0 0 1.5 2v12A1.5 1.5 0 0 0 3 15.5h10a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 13 .5H3ZM2.5 2a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v6h-11V2Z" fill="currentColor"/></svg>`,
};
